import { player } from '../../entities/athlete/player'
import {
  AudioGroups,
  AudioNames,
  PlayerStates,
  type DisciplinePhaseManager
} from '../../types'
import {
  timeManager,
  playersManager,
  fpsManager,
  modes,
  corePhasesManager,
  gsap,
  TimesTypes,
  trainingManager,
  minigameConfig,
  cameraManager,
  game,
  audioManager,
  PlayersSortTypes
} from '@powerplay/core-minigames'
import { endManager } from '@/app/EndManager'
import { startPhaseStateManager } from '../StartPhase/StartPhaseStateManager'
import {
  tableState,
  inputsState,
  gamePhaseState,
  uiState,
  trainingState,
  emotionMessagesState
} from '@/stores'
import {
  cameraConfig,
  finishPhaseConfig
} from '@/app/config'
import { timeLimitManager } from '@/app/TimeLimitManager'
import { stateManager } from '@/app/StateManager'
import { tutorialFlow } from '@/app/modes/tutorial/TutorialFlow'

/**
 * Trieda fazy pre dojazd v cieli (resp naburanie)
 */
export class FinishPhaseManager implements DisciplinePhaseManager {

  /** Ci su skipovatelne hlasky pri konecnej emocii */
  public emotionMessagesSkippable = false

  /** callback na zavolanie po skonceni fazy */
  private callbackEnd: () => unknown

  /** tween na ukoncenie fazy po animacii */
  private finishPhaseTween !: gsap.core.Tween

  /** Ci je skipovatelny tween finish phase */
  private finishPhaseTweenSkippable = false

  /** ci faza skoncila */
  private ended = false

  /** Aktualna rychlost pohybu */
  private actualSpeed = 0

  /** tween na zmenu UI stavu */
  private changeUiStateTween!: gsap.core.Tween

  /** tween na audio komentatorov */
  private commentatorsAudioDelayTween!: gsap.core.Tween

  /** kolko po starte mame zobrazit finish top box */
  private SHOW_FINISH_TOP_BOX_SECONDS = 1.5

  /** kolko po starte mame zahrat komentatorov - musi byt mensie cislo ako na zobrazenie finish top box */
  private COMMENTATORS_AUDIO_DELAY = 0.5

  /** tween pre unlock skipu finalnej emocie */
  private tweenToSkipFinalEmotions?: gsap.core.Tween

  /** Ci uz su emocie hotove */
  private emotionsDone = false

  /** Ci je hrac v top3 */
  private inTop3 = false

  /** Ci mal hrac PB */
  private isPersonalBest = false

  /** Ci mal hrac WR */
  private isWorldRecord = false

  /** Hodnota PB */
  private personalBest = 0

  /** Hodnota WR */
  private worldRecord = 0

  /** Finalna pozicia hraca */
  private position = 0

  /** Finalny pocet metrov */
  private lengthMeters = 0


  /**
   * Konstruktor
   */
  public constructor(callbackEnd: () => unknown) {

    this.callbackEnd = callbackEnd

  }

  /**
   * Pripravenie fazy
   */
  public preparePhase = (): void => {
    // nic
  }

  /**
   * Start fazy
   */
  public startPhase = (): void => {

    fpsManager.pauseCounting()

    this.reset()
    this.preparePhase()

    playersManager.setStandings(2)
    console.log('STANDINGS', playersManager.getStandings())
    tableState().dataTable = playersManager.getStandings()

    console.warn('finish phase started')

    inputsState().isVisible = false
    gamePhaseState().showSmallActionButtons = false

    player.finishAction()

    // this.actualSpeed = player.velocityManager.getVelocity() / fpsManager.fpsLimit
    console.log(`Finish speed ${this.actualSpeed}`)

    uiState().$patch({
      showTimeKeeper: true,
      showTrainingLayout: modes.isTrainingMode(),
      isTraining: modes.isTrainingMode()
    })

    this.setFinalDataAndStats()
    this.playAudioCommentatorsFinish()

    this.changeUiStateTween = gsap.to({}, {
      duration: this.SHOW_FINISH_TOP_BOX_SECONDS,
      onComplete: () => {

        uiState().$patch({
          showTimeKeeper: true,
          showTrainingLayout: modes.isTrainingMode(),
          isTraining: modes.isTrainingMode()
        })
        this.prepareEmotionMessages()

      }
    })

    // this.setFinishPhaseTween()

  }

  /**
   * Zahratie komentatorov na konci
   */
  private playAudioCommentatorsFinish(): void {

    if (
      corePhasesManager.disciplineActualAttempt < corePhasesManager.disciplineAttemptsCount ||
      modes.isTrainingMode()
    ) return

  }

  /**
   * nastavime data pre top box
   */
  private prepareEmotionMessages(): void {

    player.javelin.wasThrown = false

    // musime aj resetnut zoom kamery
    const camera = cameraManager.getMainCamera()
    camera.zoom = 1
    camera.updateProjectionMatrix()

    const lastAttempt = corePhasesManager.disciplineActualAttempt === corePhasesManager.disciplineAttemptsCount

    // tiene podla ineho objektu
    game.shadowsManager.setObjectToFollowWithLight(player.athleteObject)

    if (modes.isTutorial()) {

      this.afterEmotions(0)
      return

    }
    if (
      timeLimitManager.isOutOfTime ||
      ((player.wasFoul ||
        modes.isTrainingMode()) && !lastAttempt)
    ) {


      if (!lastAttempt) {

        this.afterEmotions(0)
        return

      }

    } else {

      player.changeCameraSettings(
        cameraConfig.emotion.idealOffset,
        cameraConfig.emotion.idealLookAt,
        cameraConfig.emotion.coefSize,
        cameraConfig.emotion.changeLerp,
        true,
      )
      if (player.javelin.javelinObject) player.javelin.javelinObject.visible = false
      player.worldEnvLinesManager.setPercentForEmotions()

      player.setState(PlayerStates.emotion)

    }

    // UI pri emocii, ak islo o posledny pokus
    if (lastAttempt) {

      let withEmotionMessages = false

      // UI pri emocii, ak islo o posledny pokus
      if (modes.isTrainingMode()) {

        // HIGH SCORE - TRENING
        trainingState().$patch({
          showLeftBoxes: false,
          newHighScore: Math.ceil(trainingManager.getNewPotentialHighScore()),
          showNewHighScore: trainingManager.isNewHighScore()
        })

      } else {

        // UI veci mimo TG
        withEmotionMessages = this.showEmotionMessages()


      }

      audioManager.stopAudioByGroup(AudioGroups.audience)
      audioManager.play(AudioNames.audienceOutro)

      if (withEmotionMessages) return

      this.afterEmotions(finishPhaseConfig.finishWaitingDuration)

    }

  }

  /**
   * Spravenie veci po emociach
   * @param duration - Dlzka finish tweenu
   */
  public afterEmotions(duration: number): void {

    // iba raz vykonavame
    if (this.emotionsDone) return

    this.tweenToSkipFinalEmotions?.kill()

    trainingState().showNewHighScore = false
    emotionMessagesState().showMessage = false

    this.emotionsDone = true
    this.setFinishPhaseTween(duration)

  }

  /**
   * Nastavenie timeru na skip final emocie
   */
  private setTimerToSkipFinalEmotions(): void {

    // dame timer na skip poslednej emocie s hlaskami
    this.tweenToSkipFinalEmotions = gsap.to({}, {
      duration: 1.5,
      onComplete: () => {

        this.emotionMessagesSkippable = true

      }
    })

  }

  /**
   * Nastavenie finalnych dat a statistik
   */
  private setFinalDataAndStats(): void {

    playersManager.setStandings(2)

    this.lengthMeters = playersManager.getBestResultOfStandings(PlayersSortTypes.descending, undefined, true)
    
    this.personalBest = playersManager.getPlayer().personalBest
    if (this.personalBest === 0) this.personalBest = minigameConfig.dnfValue
    this.worldRecord = endManager.worldRecord
    this.position = playersManager.getPlayerActualPosition(player.uuid)
    this.inTop3 = this.position <= 3
    this.isPersonalBest = this.lengthMeters >= this.personalBest
    this.isWorldRecord = this.lengthMeters >= this.worldRecord

  }

  /**
   * nastavime emocne message
   * @returns True, ak zobrazujeme emocnu hlasku
   */
  public showEmotionMessages(): boolean {

    // ak mame nejaku hlasku/y, tak zobrazime kameru kusok inak
    if (
      modes.isTutorial() ||
      ((modes.isDailyLeague() || modes.isTournament()) && !playersManager.isPlayerImproved()) ||
      (!this.inTop3 && !this.isPersonalBest && !this.isWorldRecord)
    ) return false

    startPhaseStateManager.hideAllTextMessages()
    stateManager.hideAttemptsTable()

    let recordText = ''
    let recordValue = ''
    if (this.isPersonalBest) {

      recordText = this.lengthMeters > this.personalBest ? 'newPersonalBest' : 'personalBest'
      recordValue = this.lengthMeters.toFixed(2)

    }
    if (this.isWorldRecord) {

      recordText = this.lengthMeters > this.worldRecord ? 'newWorldRecord' : 'worldRecord'
      recordValue = this.lengthMeters.toFixed(2)

    }

    emotionMessagesState().$patch({
      showMessage: true,
      firstLineText: this.inTop3 ? 'congratulations' : '',
      firstLineTextSecond: modes.isTournament() ? '' : recordText,
      secondLineText: this.inTop3 ? this.position : 0,
      secondLineTextSecond: modes.isTournament() ? '' : recordValue,
    })

    // dame timer na skip poslednej emocie s hlaskami
    this.setTimerToSkipFinalEmotions()

    return true

  }

  /**
   * Kontrola a riesenie inputov
   */
  public handleInputs(): void {

    // skip na emocie
    if (this.emotionMessagesSkippable) {

      this.tweenToSkipFinalEmotions?.kill()
      this.emotionMessagesSkippable = false
      this.afterEmotions(0)

      return

    }

    // skip na tween finish phase
    if (this.finishPhaseTweenSkippable) {

      this.onFinishPhaseTweenEnd()
      return

    }

    // skipovanie emocii mimo finalneho pokusu
    player.athleteAnimationManager.handleInputs()

  }

  /**
   * Aktualizovanie fazy
   */
  public update = (): void => {
    // nic

  }

  /**
   * Zobrazenie finalnej tabulky
   */
  private prepareFinishTable() {

    timeManager.setActive(TimesTypes.game, false)
    // data pre tabulku
    playersManager.setStandings(2)
    console.log('STANDINGS', playersManager.getStandings())
    tableState().dataTable = playersManager.getStandings()

  }

  /**
   * Ukoncene fazy
   * @param type - Typ ukoncenia
   */
  public finishPhase = (): void => {

    if (this.ended) return

    tutorialFlow.finishPassed()

    this.prepareFinishTable()
    this.ended = true

    this.emotionMessagesSkippable = false

    if (this.finishPhaseTween) this.finishPhaseTween.kill()
    if (this.changeUiStateTween) this.changeUiStateTween.kill()
    if (this.commentatorsAudioDelayTween) this.commentatorsAudioDelayTween.kill()

    uiState().$patch({
      showTimeKeeper: false,
      showTrainingLayout: false,
      isTraining: modes.isTrainingMode(),
      showWind: false
    })

    // resetujeme vsetky hlasky, aby nahodou neostali
    startPhaseStateManager.hideTextMessage(1)
    startPhaseStateManager.hideTextMessage(2)

    if (corePhasesManager.disciplineActualAttempt < corePhasesManager.disciplineAttemptsCount) {

      this.callbackEnd()
      return

    }

    fpsManager.pauseCounting()
    endManager.sendLogEnd()
    endManager.sendSaveResult()

    console.warn('finish phase ended')
    this.callbackEnd()

  }

  /**
   * Co sa ma stat na konci tweenu pre finish phase
   */
  private onFinishPhaseTweenEnd(): void {

    this.finishPhaseTweenSkippable = false
    this.finishPhaseTween?.kill()
    this.finishPhase()

  }

  /**
   * sets tween to finish phase
   * @param duration - Dlzka finish tweenu
   */
  public setFinishPhaseTween(duration: number): void {

    if (duration === 0) {

      this.finishPhase()
      return

    }

    // skipovanie dame az po chvilke
    gsap.to({}, {
      duration: 0.2,
      onComplete: () => {

        this.finishPhaseTweenSkippable = true

      }
    })

    this.finishPhaseTween = gsap.to({}, {
      onComplete: () => {

        this.onFinishPhaseTweenEnd()

      },
      duration
    })

  }

  /**
   * reset fazy
   */
  public reset(): void {

    this.ended = false
    if (this.changeUiStateTween) this.changeUiStateTween.kill()
    if (this.commentatorsAudioDelayTween) this.commentatorsAudioDelayTween.kill()
    this.emotionMessagesSkippable = false
    this.emotionsDone = false
    this.finishPhaseTweenSkippable = false

  }

}
